import { Injectable } from '@angular/core';

import moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class CoreUtilityService {
  /**
   * Format date in specific format
   * @param date - date
   */
  formatDate(date: Date): string {
    return moment(date).format('YYYY-MM-DD');
  }

  /**
   * This methid will set the number to decimal
   * @param number The number whose decimal need to be set
   */
  setDecimal(value) {
    return parseFloat(value).toFixed(2);
  }

  /**
   * Strict compare function
   * @param val1 - value 1
   * @param val2 - value 2
   */
  strictCompare(val1: any, val2: any, strictMode: boolean = true) {
    try {
      let result: boolean;
      if (strictMode) {
        result = val1.toString().toLowerCase() === val2.toString().toLowerCase();
        // tslint:disable-next-line: triple-equals
      } else {
        // tslint:disable-next-line: triple-equals
        result = val1.toString().toLowerCase() == val2.toString().toLowerCase();
      }
      return result;
    } catch (error) {
      throw error;
    }
  }

  /**
   * This function converts date Obj in date format
   * @param  dateObj: This is the date object
   */
  convertJSONInDate(dateObj) {
    return ('0' + dateObj.day).slice(-2) + '/' + ('0' + dateObj.month).slice(-2) + '/' + dateObj.year;
  }

  /**
   * This function is used to disable the browser back button
   */
  disableBrowswerBack() {
    history.pushState(null, null, location.href);
    window.onpopstate = () => {
      history.go(1);
    };
  }

  /**
   * This function will extract required information from browser URL
   * @param url - router url
   * @param compareObj - compare url data to predefined object
   * @param index - index from which we need to extract required data
   */
  extractDataFromURL(url, compareObj, index) {
    const urlValue = url.split('/')[index];
    if (compareObj) {
      return compareObj.hasOwnProperty(urlValue?.toUpperCase()) ? compareObj[urlValue.toUpperCase()] : null;
    }
    return urlValue;
  }

  /**
   * Converts file size from KB to MB
   * @param size - size in KB
   */
  kbTomb(size) {
    return Math.round(size / 1024);
  }
}
